<div class="scroll-modal-content">
    <div class="tab-content">
        <ui-standalone-tabs
            [options]="(tabsOptions$ | async) ?? []"
            [selectedTabId]="selectedTabId"
            (selectedTabIdChange)="selectedTabIdChange($event)"
        />
    </div>

    <div class="p-3">
        <div
            class="tab"
            [ngClass]="{
                visible: 0 === selectedTabId
            }"
        >
            <!-- Specific config -->
            <tailored-widget-config-editor
                [configToEdit]="configToEdit"
                [acceptedDashboardModes]="actionIntent.requiredDashboardModes || []"
                [dashboardScopeType]="actionIntent.requiredDashboardScopeType || null"
                [isEditing]="actionIntent.editionIntent !== undefined"
                (configChanged)="specificConfigChanged($event)"
            />
            <!-- Preview -->
            @if (isConfigValid) {
                @if (dataPointsWarningLevel() === 'performance') {
                    <advizeo-status-message
                        class="preview"
                        status="info"
                        [message]="'TAILORED_WIDGET.EDITOR.PERFORMANCE_WARNING' | translate"
                    />
                } @else if (dataPointsWarningLevel() === 'limit') {
                    <advizeo-status-message
                        class="preview"
                        status="warning"
                        [message]="'TAILORED_WIDGET.EDITOR.DATA_LIMIT_REACHED' | translate"
                    />
                }
                <tailored-widget-spawner
                    class="preview"
                    [widgetConfig]="debouncedConfig$ | async"
                    [context]="context$ | async"
                    [class.show-preview]="debouncedConfig$ | async"
                    (dataPointCount)="onDataPointCountChange($event)"
                />
            }
        </div>

        @if (canBeReferencedInCatalog$ | async) {
            <ui-section
                class="tab"
                [ngClass]="{
                    visible: 1 === selectedTabId
                }"
                [title]="'TAILORED_WIDGET.CARD_TITLE.SAVE_IN_CATALOG' | translate"
            >
                <ui-section-content>
                    <!-- Base config -->
                    <form [formGroup]="widgetBaseConfigForm">
                        <ui-field [label]="'TAILORED_WIDGET.EDITOR.NAME' | translate">
                            <input advizeoInput formControlName="name" [required]="true" />
                        </ui-field>
                        <div class="display-flex flex-direction-column medium-margin-top">
                            <ui-checkbox formControlName="isInCatalog" [label]="'TAILORED_WIDGET.EDITOR.IS_IN_CATALOG' | translate" />
                            @if (widgetBaseConfigForm.value.isInCatalog) {
                                <ui-checkbox
                                    formControlName="canBeMonoSite"
                                    [label]="'TAILORED_WIDGET.EDITOR.CAN_BE_MONO_SITE' | translate"
                                    [disabled]="isDashboardModeDisabled(DashboardMode.MONO)"
                                />
                                <ui-checkbox
                                    formControlName="canBeMultiSite"
                                    [label]="'TAILORED_WIDGET.EDITOR.CAN_BE_MULTI_SITE' | translate"
                                    [disabled]="isDashboardModeDisabled(DashboardMode.MULTI)"
                                />
                            }
                        </div>
                    </form>
                </ui-section-content>
            </ui-section>
        }
    </div>
</div>
<div class="advizeo-toolbar toolbar-right medium-margin">
    <button ui-button color="primary" [disabled]="!(isConfigValid && widgetBaseConfigForm.valid)" (click)="saveWidget()">
        {{ 'BUTTONS.VALIDATE' | translate }}
    </button>
</div>
